 
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#A41735',
    darken1: colors.purple.darken2,
  },
  secondary: {
    base: '#464646',
    darken1: colors.grey.darken3,
  },
  wedrivesecondary: '#B9CADD', 
  anchor: '#1976d2', 
  wedrivetitle: '#0099CC',
  light: '#FEFEFE'
}